export const CONTRACT_STATUS = {
  1: 'pending',
  2: 'active',
  3: 'expired',
  4: 'terminated',
  5: 'term_expired',
};
